import React from 'react';
import Modal from './Model';
import Button from 'react-bootstrap/Button';

interface ScopeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectScope: (scope: 'single' | 'future') => void;
  action: 'edit' | 'delete'; // To customize modal title/text
}

const ScopeModal: React.FC<ScopeModalProps> = ({ isOpen, onClose, onSelectScope, action }) => {
  if (!isOpen) return null;

  const title = action === 'edit' ? 'Edit Recurring Event' : 'Delete Recurring Event';
  const option1Text = action === 'edit' ? 'This event only' : 'This event only';
  const option2Text = action === 'edit' ? 'This and following events' : 'This and following events';

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="p-6 bg-white dark:bg-gray-800 rounded-lg shadow-xl">
        <h2 className="text-xl font-bold mb-4 text-gray-800 dark:text-gray-200">{title}</h2>
        <p className="mb-6 text-gray-600 dark:text-gray-400">Please select how you would like this change to apply to your recurring event series.</p>

        <div className="flex flex-col gap-3">
          <Button 
            variant="outline-primary" 
            onClick={() => onSelectScope('single')}
            className="w-full text-left p-3 border rounded-md hover:bg-purple-100 dark:hover:bg-gray-700 hover:border-purple-500 dark:hover:border-purple-400 transition-all duration-200"
            style={{ '--bs-btn-hover-bg': '#f3e5f5', '--bs-btn-hover-border-color': '#7E57C2', '--bs-btn-color': '#7E57C2', '--bs-btn-border-color': '#7E57C2' } as React.CSSProperties}
          >
            <strong className="font-semibold">{option1Text}</strong>
            <span className="block text-sm text-gray-500 dark:text-gray-400">Only this instance will be affected.</span>
          </Button>
          <Button 
            variant="outline-primary" 
            onClick={() => onSelectScope('future')}
            className="w-full text-left p-3 border rounded-md hover:bg-purple-100 dark:hover:bg-gray-700 hover:border-purple-500 dark:hover:border-purple-400 transition-all duration-200"
            style={{ '--bs-btn-hover-bg': '#f3e5f5', '--bs-btn-hover-border-color': '#7E57C2', '--bs-btn-color': '#7E57C2', '--bs-btn-border-color': '#7E57C2' } as React.CSSProperties}
          >
            <strong className="font-semibold">{option2Text}</strong>
            <span className="block text-sm text-gray-500 dark:text-gray-400">This and all subsequent instances in the series will be affected.</span>
          </Button>
        </div>

        <div className="flex justify-end mt-6">
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ScopeModal;
